module.exports = __webpack_public_path__ + "instagram-rounded-1118efe1271ae527bc93.svg";